import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { httpinstance } from "../../axios/api";
const initialState = {
  queryDetails: null,
  manualQuoteDetails : {}
};


export const getAllOriginDestinationCharges = createAsyncThunk(
    'getAllOriginDestinationCharges',
    async (value, { rejectWithValue }) => {
        try {
            const response = await httpinstance.get("manual-quote/get-all-sw-charges");
            return response.data.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || 'Something went wrong');
        }
    }
);


export const addManualQuote = createAsyncThunk(
  'addManualQuote',
  async (value, { rejectWithValue }) => {
      try {
          const response = await httpinstance.post("/manual-quote", value);
          return response?.data;
      } catch (err) {
          return rejectWithValue(err.response?.data || 'Something went wrong');
      }
  }
);

export const getAllManualQuoteById = createAsyncThunk(
  'getAllManualQuoteById',
  async (id, { rejectWithValue }) => {
      try {
          const response = await httpinstance.get(`/manual-quote/get-manual-quote/${id}`);
          return response.data;
      } catch (err) {
          return rejectWithValue(err.response?.data || 'Something went wrong');
      }
  }
);

export const getManualQuoteDetailById = createAsyncThunk(
  'getManualQuoteDetailById',
  async (id, { rejectWithValue }) => {
      try {
          const response = await httpinstance.get(`/manual-quote/get-manual-quote-detail/${id}`);
          return response.data;
      } catch (err) {
          return rejectWithValue(err.response?.data || 'Something went wrong');
      }
  }
);

export const editManualQuote = createAsyncThunk(
  'editManualQuote',
  async (value, { rejectWithValue }) => {
      try {
          const response = await httpinstance.put(`/manual-quote/${value.manualqueryId}`, value);
          return response?.data;
      } catch (err) {
          return rejectWithValue(err.response?.data || 'Something went wrong');
      }
  }
);


const manualQuoteSlice = createSlice({
  name: "manualQuoteSlice",
  initialState,
  reducers: {
    setQueryDetail(state, action) {
      state.queryDetails = action.payload;
    },
    setManualQuoteDetail(state, action) {
      state.queryDetails = action.payload.queryDetails;
      state.manualQuoteDetails = action.payload.manualQuoteDetails
    },
    clearManualQuote(state , action){
      state.queryDetails = null
      state.manualQuoteDetails = {}
    }
  },
});
export const { setQueryDetail, setManualQuoteDetail , clearManualQuote} = manualQuoteSlice.actions;
export default manualQuoteSlice.reducer;
